export const C_ID_UPDATED = "C_ID_UPDATED";
export const C_UTC_UPDATED = "C_UTC_UPDATED";
export const C_URATE_UPDATED = "C_URATE_UPDATED";
export const C_CRATE_UPDATED = "C_CRATE_UPDATED";
export const C_UCRATE_UPDATED = "C_UCRATE_UPDATED";
export const C_UPDATED = "C_UPDATED";
export const C_INVALIDATED = "C_INVALIDATED";

export const C_SET_LEFT_RFS = "C_SET_LEFT_RFS";
export const C_SET_RIGHT_RFS = "C_SET_RIGHT_RFS";